import React from 'react';
import { Link } from 'react-router-dom';
import '../styles.css';

const HeroSection: React.FC = () => {
  return (
    <section className='hero-section'>
      {/* Dot pattern background */}
      <div className='hero-dot-pattern' />

      {/* Animated yellow blur effects */}
      <div className='hero-blur-1' />
      <div className='hero-blur-2' />

      {/* Content */}
      <div className='hero-content'>
        <h1>Defense Collaborative Research Platform</h1>
        <p>
          The trusted platform for defense research,
          <br />
          education and collaboration.
        </p>
        <div className='hero-actions'>
          <Link to='/athena' className='hero-cta'>
            Download Athena
          </Link>
          <Link to='/request-account' className='hero-cta hero-cta-secondary'>
            Request Account
          </Link>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
